import React from 'react';
import styled from 'styled-components';
import breakpointsMinWidth from '../../../../../../styling/breakpointsMinWidth';
import { JOB_SPECIFIC, SAMPLE_COVER_LETTER } from '../enums.generateCl';

const CardWrap = styled.div`
  padding: 16px 20px;
  display: flex;
  gap: 14px;
  border-radius: 16px;
  cursor: pointer;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.25);
  scale: 1;
  transition: all 0.1s ease-in;
  &:hover {
    scale: 1.01;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.5);
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding: 18px 24px;
  }
`;
const CardImage = styled.div`
  width: 85px;
  height: 80px;
  padding: 8px 6px;
  border-radius: 4px;
  border: 1px solid #e1e1e1;

  @media ${breakpointsMinWidth.tabletLg} {
    width: 95px;
    height: 90px;
    padding: 12px 10px;

    svg {
      width: 70px;
      height: 58px;
    }
  }

  svg {
    width: 76px;
    height: 64px;
  }
`;
const CardData = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const HeadingText = styled.div`
  color: #1f1f1f;
  font-size: 14px;
  line-height: 18px;

  @media ${breakpointsMinWidth.tabletLg} {
    font-size: 16px;
    line-height: 24px;
  }
`;
const SubHeadingText = styled.div`
  color: #545454;
  font-size: 12px;
  line-height: 14px;

  @media ${breakpointsMinWidth.tabletLg} {
    font-size: 14px;
    line-height: 16px;
  }
`;

const Card = ({
  heading,
  subHeading,
  Image,
  setWizardAnimation,
  handleClosePopup,
  type,
  setModal,
  onClose,
}) => {
  const handleClick = () => {
    if (type === SAMPLE_COVER_LETTER) {
      setWizardAnimation(true);
      handleClosePopup();
      onClose();
    }
    if (type === JOB_SPECIFIC) {
      setModal(JOB_SPECIFIC);
    }
  };
  return (
    <CardWrap onClick={handleClick}>
      <CardImage>
        <Image />
      </CardImage>
      <CardData>
        <HeadingText>{heading}</HeadingText>
        <SubHeadingText>{subHeading}</SubHeadingText>
      </CardData>
    </CardWrap>
  );
};

export default Card;
